<app-header *ngIf="visibility" (EnableMenus)="onOpen($event)"></app-header>
<router-outlet></router-outlet>
